<!-- 書類の使用頻度のサンプル datasetsとかlabels入れたら表示できる-->
<script>
import { Pie } from "vue-chartjs";
import "chartjs-plugin-colorschemes";
export default {
  extends: Pie,
  name: "DocumentFrequency",
  type: "pie",
  data() {
    return {
      data: {
        datasets: [
          {
            data: [10, 20, 30, 40, 50],
          },
        ],
        labels: ["Red", "Yellow", "Blue"],
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            colorschemes: {
              scheme: "tableau.Classic20",
            },
          },
        },
      },
    };
  },
  computed: {
    documentFrequencyList: function () {
      return this.$store.getters["domain/documentFrequencyList"];
    },
  },
  watch: {
    documentFrequencyList(val) {
      if (val) {
        this.overwriteGraphData(val);
      }
      this.renderChart(this.data, this.options);
    },
  },
  mounted() {
    const val = this.$store.getters["domain/documentFrequencyList"];
    this.overwriteGraphData(val);
    this.renderChart(this.data, this.options);
  },
  methods: {
    overwriteGraphData: function (val) {
      let documentId = [];
      let applyCount = [];
      for (let i = 0; i < val.length; i++) {
        const data = val[i];
        documentId.push(data.document_id);
        applyCount.push(data.application_count);
      }
      this.$set(this.data.datasets[0], "data", applyCount);
      this.$set(this.data, "labels", documentId);
    },
  },
};
</script>
